"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interactions = void 0;
const apis_1 = require("./apis");
exports.Interactions = {
    send: apis_1.send,
    onComplete: apis_1.onComplete,
};
